// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-30{width:30% !important}.compare__title{margin-top:60px}.compare__tooltip.btn{border-radius:50%;width:24px;height:24px;line-height:24px;text-align:center;min-width:24px;margin-left:10px}.border-title{border-bottom:1px solid #dee2e6;display:flex;justify-content:space-between;align-items:center}\n", ""]);
// Exports
module.exports = exports;
